import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
import 'slick-carousel'; 
import './libs/slider';
import './libs/kf';
// import './libs/isInViewport';
import Header from './libs/header';
import AOS from 'aos';


// AOS.init(); 
AOS.init({
    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 120, // offset (in px) from the original trigger point
    delay: 200, // values from 0 to 3000, with step 50ms
    duration: 500, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: false, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

});
$('#header .header').each((i, e) => {
  new Header(e, $(e));
});

// Your scripts here
// $('.ham').on('click', () => {
//   $('.ham, .header__mobile-menu').toggleClass('active');
// });

const $headerE = $('#header');
const $headerP = $('.header');
const $headerT = $('.topheader');
const $btt = $('.backtotop');
$(window).on('scroll', () => {
  let scroll = window.scrollY;
  if (scroll > $headerP.height()) {
    scroll = $headerP.height();
    $headerE.addClass('header__sticky_head');
    $btt.addClass('header__sticky_head');
    $headerT.addClass('topheader__sticky_tophead');
  } else {
    $headerE.removeClass('header__sticky_head');
    $btt.removeClass('header__sticky_head');
    $headerT.removeClass('topheader__sticky_tophead');
  }
  // $headerE.css('margin-top', scroll * -1 + 'px');
});
$(window).trigger('scroll');

$('.backtotop').on('click', function(){

  $("html, body").animate({scrollTop: 0}, 1000);
});

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};




$(window).on('resize scroll', function(e) {
  
  if ($('.opak__l.active').isInViewport()) {
    $('.opak__l').each(function () {
      $('.opak__l').removeClass('active');
      var $this = $(this);
      console.log($this);
      $({ Counter: 0 }).animate({ Counter: 100 }, {
        duration: 7000,
        easing: 'swing',
        step: function () {
          $this.text(Math.ceil(this.Counter));
        }
      });
    }); 
    e.stopPropagation();
  } 
});



// $(window).on('resize scroll', function(e) {
//   if ($('.kor__slider').isInViewport()) {
//       const slider = $(".kor__slider"); 
  
//   //Implementing navigation of slides using mouse scroll
//       slider.on('wheel', (function(e) {
//         e.preventDefault();
//         if (e.originalEvent.deltaY >  0) {
//           $(this).slick('slickNext');
//         } else {
//           $(this).slick('slickPrev');
//         }
//       }));
//   } 
//   });

  
$(document).ready(() => {
  

// $("#vid")[0].src += "&autoplay=1";
var width = $('.film__bot--nkp img').width();
var height = $('.film__bot--nkp img').height();
console.log(width);
$('.film__bot').css('width', width);
$('#vid').css('width', width - 10);
$('#vid').css('height', height - 15);
});

$('.pm__exit').on('click tap', function(){
    $('.pm').removeClass('active');
    $("iframe").each(function() { 
      var src= $(this).attr('src');
      $(this).attr('src',src);  
});
})
$('.film__top--play,.film__bot--nkp').on('click tap', function(){
    $('.pm').addClass('active');
})

$(".menu-item.formula").click(function (){
  $('html, body').animate({
    scrollTop: $('#formula').offset().top - 50
}, 500, 'linear');
});
$(".menu-item.korzysci").click(function (){
  $('html, body').animate({
    scrollTop: $('#korzysci').offset().top - 50
}, 500, 'linear');
});
$(".menu-item.testnkp").click(function (){
  console.log('asdasd');
  $('html, body').animate({
    scrollTop: $('#testnkp').offset().top - 50
}, 500, 'linear');
});
$(".menu-item.opakowania").click(function (){
  $('html, body').animate({
    scrollTop: $('#opakowania').offset().top - 50
}, 500, 'linear');
});
$(".menu-item.menu_kontakt").click(function (){
  $('html, body').animate({
    scrollTop: $('#menu_kontakt').offset().top - 50
}, 500, 'linear');
});

